<agr-page-sidesheet
  [pageTitle]="'legalNitrogenWorkingCoefficient' | translate"
  (primaryAction)="importItems()"
  [primaryActionText]="'import' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="cloud_upload"
>
  <app-year-filter
    sidesheet
    [filter]="legalNitrogenWorkingCoefficientsFilter$ | async"
    (update)="updateFilter($event)"
    (filterEnabled)="setFilterEnabled($event)"
    (filterReset)="resetFilter()"
  >
  </app-year-filter>

  <ng-container actions>
    @if (isMobile$ | async) {
      <button mat-icon-button (click)="setSearch()" data-test="crop-variety-filter">
        <mat-icon>search</mat-icon>
      </button>
    }
  </ng-container>

  <div class="mat-button-row" actions>
    <button mat-button actionIcon="add" (click)="addItem()" data-test="add-item">
      <mat-icon>add</mat-icon>
      {{ 'add' | translate }}
    </button>
  </div>

  <agr-notification-empty
    [isEmpty]="!(coefficients$ | async)?.length"
    [emptyTitle]="'itemsEmpty' | translate"
    [emptyDescription]="((filterEnabled$ | async) ? 'noItemsFound' : 'noItems') | translate"
    emptyActionIcon="clear"
    [emptyActionText]="'resetFilter' | translate"
    [showEmptyAction]="filterEnabled$ | async"
    (emptyAction)="resetFilter()"
  >
    <div class="container">
      <agr-table [config]="tableConfig" data-test="norms-table"></agr-table>
    </div>
  </agr-notification-empty>
</agr-page-sidesheet>
